import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "-6.965 238.143 612.279 606.499",
  "content": "<symbol viewBox=\"-6.965 238.143 612.279 606.499\" id=\"calendar\"><path d=\"M503.677 619.212h-77.873v-78.387h77.873v78.387zm-330.091-78.386H95.714v78.387h77.872v-78.387zm164.19 0h-77.872v78.387h77.872v-78.387zm267.539-220.472v524.288H-6.965V320.354h78.992v-82.211h47.396v82.211h372.342v-82.211h47.396v82.211h66.154zm-47.397 153.085H40.432v323.807h517.486V473.439zm0-105.689H40.432v58.292h517.486V367.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/calendar.svg
// module id = 149
// module chunks = 0